import { useOktaAuth } from "@okta/okta-react";
import React, { useEffect } from "react";
import { toRelativeUrl } from "@okta/okta-auth-js";

interface SecureRouteProps {
  children: React.ReactElement;
}

export const SecureRoute: React.FC<SecureRouteProps> = ({ children }) => {
  const { oktaAuth, authState } = useOktaAuth();

  useEffect(() => {
    if (!authState) {
      return;
    }

    if (!authState.isAuthenticated) {
      const originalUri = toRelativeUrl(
        window.location.href,
        window.location.origin
      );
      oktaAuth.setOriginalUri(originalUri);
      oktaAuth.signInWithRedirect();
    }
  }, [authState, oktaAuth]);

  if (!authState || !authState.isAuthenticated) {
    return null;
  }

  return children;
};
